import React, { useEffect } from "react";
import "./about.css";
import Navbar from "../Navbar/Navbar";
import AboutHeader from "./AboutHeader";
import AboutNavbar from "./AboutNavbar";
import Footer from "../Footer/Footer";

const AboutUs = () => {
  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.2, // kicsit előbb figyel
      rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`; // kicsit lassabb chain effekt
      appearOnScroll.observe(el);
    });
  }, []);
  return (
    <>
    <AboutNavbar/>
    <AboutHeader/>
    <div className="about-wrapper">
      {/* Első szekció */}
     <section className="about-section">
  <div className="about-content first">
    {/* Kép + rövid szöveg flex konténer */}
    <div className="about-image-and-text">
      <div className="about-image fade-in">
        <img src="kate.png" alt="Personal" />
      </div>
      <div className="about-text fade-in">
        <h1>Dr. Katie Seidler</h1>
        <h3>Director</h3>
        <p>
          Dr. Katie Seidler is a clinical and forensic psychologist with a PhD in the area of the cultural motivations for interpersonally violent crime. Since completing her PhD, Dr. Seidler’s primary area of academic interest has been in terrorism and violent extremism. In addition to a PhD, Dr. Seidler has a Masters degree in Clinical Psychology and a Graduate Certificate in Terrorism and Security Studies.
        </p>
        <h3>Contact:</h3>
        <p>katie@threatadvisorygroup.com</p>
      </div>
    </div>

    {/* Hosszú szöveg alul */}
    <div className="about-text-2 fade-in">
      She is an Honorary Research Fellow with the Centre for Terrorism and Security Studies at Charles Sturt University and has actively contributed to a research partnership with the University of Queensland.
      Dr. Seidler has almost 30 years experience as a psychologist, which has included a speciality in the assessment, treatment and management of risk, including within various Government and non-Government sectors. Her work has included the provision of expert evidence in Court, 
      advising organisations on individual risk management, working with other professionals to manage complex clients, assessing child protection and family violence risk, supervising a range of mental health professionals and developing and implementing programmes in various domains. Further to this, Dr. 
      Seidler has expertise in insider and security risk and organisational suitability assessments. Dr. Seidler also has experience in professional training, program development and academia. 
      She is a full member of both the Colleges of Clinical and Forensic Psychologists of the Australian Psychological Society, in addition to holding a number of relevant professional memberships.
    </div>
  </div>
</section>

      <hr className="about-divider fade-in" />

      {/* Második szekció */}
     <section className="about-section">
  <div className="about-content second">
    {/* Kép + rövid szöveg flex konténer */}
    <div className="about-image-and-text-2 ">
      <div className="about-text-4 fade-in">
        <h1>Dr. Chelsey Dewson</h1>
        <h3>Director</h3>
        <p>
          Dr Chelsey Dewson is a forensic psychologist with over 19 years’ experience working within the public and private sectors.
          She has undergraduate degrees in psychology and criminology, a master’s degree in forensic psychology and a PhD in investigative psychology. 
          She has studied in Australia and the United Kingdom (UK), where she has gained knowledge and expertise alongside world-renowned experts in the field. 
          Dr Dewson also holds a diploma in personnel and operations management, a diploma in government, and a certificate IV in frontline management.
        </p>
        <h3>Contact:</h3>
        <p>chelsey@threatadvisorygroup.com</p>
      </div>

      <div className="about-image-2 fade-in">
        <img src="chelsey.png" alt="Second" />
      </div>
    </div>

    {/* Hosszú szöveg alul, teljes szélességgel */}
    <div className="about-text-3 fade-in">
      Dr Dewson spent the early part of her career working with adolescents in forensic settings, as a Juvenile Justice Officer, a Restorative Justice Officer and a Psychologist. 
      She then spent over 10 years working as a psychologist with adults in custodial environments, primarily in a High-Risk sexual offender unit. In 2016, 
      Dr Dewson transitioned into the private sector, where she worked with both community and custody-based offenders, military personnel, and law enforcement officers. 
      She had a particular interest in high-risk offenders, having worked within post-sentence detention legislative frameworks, for sexual, violent and terrorism offenders. 
      After reforms were made in 2017, Dr Dewson was at the forefront of providing risk assessments for high-risk violent extremists, where she worked across jurisdictions to provide expert consultation. 
      She is often asked to provide insight into complex human presentations and risks that individuals or groups pose to an organisation. Dr Dewson has presented at professional conferences in both Australia and overseas, specifically regarding the human factors associated with problematic behaviour, risk assessments and the development of management plans.
      Dr Dewson is a registered psychologist with the Australian Health Practitioner Regulation Agency (AHPRA), where she is endorsed as a forensic psychologist. 
      She is a member of the Australian Psychological Society and is a Fellow of the Forensic College.
        </div>
      </div>
    </section>
    </div>
    <Footer/>
    </>
  );
};

export default AboutUs;
